import { Injectable } from '@angular/core';
import { Datepicker } from '../models';

@Injectable({
  providedIn: 'root'
})

export class DatetimeService {

  defaultTimeZone: string = 'Asia/Almaty';
  defaultLocal: string = 'ru-RU';

  constructor() {}


  /**
   * 
   * @param date 
   * @returns Datepicker
   */
  convertDateForDatepicker(date: any): Datepicker {

    let _date = new Date(date);

    return {
      year:  _date.getFullYear(), 
      month: _date.getMonth() + 1, 
      day:   _date.getDate()
    }
  }


  /**
   * 
   * @param date Datepicker
   * @returns string
   */
  convertDateForDB(date: Datepicker): string {

    let month = date.month < 10 ? '0' + date.month : date.month;
    let day   = date.day < 10 ? '0' + date.day : date.day;
    
    return date.year + '-' + month + '-' + day;
  }


  /**
   * 
   * @param value 
   */
  convertDateTime(value: string): string {
    
    let options: Intl.DateTimeFormatOptions = {
      timeZone: this.defaultTimeZone,
      year:     "numeric",
      month:    "2-digit",
      day:      "2-digit",
      hour12 :  false,
      hour:     "2-digit",
      minute:   "2-digit"
    }
    
    return new Date(value).toLocaleString(this.defaultLocal, options);
  }


  /**
   * 
   * @param datetime подача даты в формате с знаками - и +06 на конце не корректно работает в браузере Firefox
   */
  convertStringToDate(datetime: string): Date {
    
    if(typeof datetime == 'string'){

      if(datetime.length > 19){
      
        datetime = datetime.substring(0, 19);   // trim timezone
      }
      
      datetime = datetime.replace(/-/g,'/');    // replaces all occurances of "-" with "/"
    }

    return new Date(datetime);
  }
}
